import React from 'react'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { Divider } from '@material-ui/core'
import { calculatorVar } from '../../../apollo/reactive-vars'
import { BuildingFragment } from '../../../generated/graphql'
import { BuildingTabCommonHeader } from '../BuildingTabCommonHeader'
import { ReportPurchasedEnergyTable } from '../../system-container/report/ReportPurchasedEnergyTable'
import { ReportDemandsTable } from '../../system-container/report/ReportDemandsTable'
import { Section } from '../../common/Section'
import { Printable } from '../../common/Printable'
import { ReportEnergySystemsSection } from '../../system-container/report/ReportEnergySystemsSection'
import { buildingNetEnergySubCategories } from '../../../provider/result-categories'

type Props = {
  building: BuildingFragment
}

export function BuildingReportTab({ building }: Props): React.ReactElement {
  const calculator = useReactiveVar(calculatorVar)
  const { t } = useTranslation()

  const buildingCalculator = calculator?.findBuilding(building.id)

  if (!buildingCalculator) {
    return <></>
  }

  const providers = buildingCalculator.getProviders()

  return (
    <Printable>
      <BuildingTabCommonHeader building={building} />

      <Divider />

      <Section title={t('report.purchasedEnergies')}>
        <ReportPurchasedEnergyTable building={building} providers={providers} />
      </Section>

      <Divider />

      <ReportEnergySystemsSection providers={providers} />

      <Divider />

      <Section title={t('report.totalEnergyDemands')}>
        {buildingNetEnergySubCategories.map((subCategory) => (
          <ReportDemandsTable
            key={`demands-by-${subCategory.nameKey}-table`}
            demandFlows={buildingCalculator.getPrimaryDemands()}
            subCategory={subCategory}
            area={building.area}
          />
        ))}
      </Section>
    </Printable>
  )
}
